module.exports = __webpack_public_path__ + "static/media/straighten_07.b827a9d5.png";